<template>
  <div class="w-full">
    <div class="mt-2" v-for="(course, index) in courses" :key="course._id+index">
      <div
        class="flex items-start justify-between flex-nowrap w-full cursor-pointer"
        @click="() => callback(course._id, index)"
      >
      <div class="flex items-start cursor-pointer">
        <!-- <h3
          class="font-medium text-xl inline-block mr-2"
          :class="
            currentCourse == course._id
              ? ' text-primaryLink '
              : '  text-gray-500'
          "
        >
          {{ index + 1 }}.
        </h3> -->
        <h3
          class="font-medium text-xl inline-block"
          :class="
            currentCourse == course._id
              ? ' text-primaryLink font-semibold'
              : '  text-gray-700'
          "
        >
          {{ course.title }}
        </h3>
      </div>
        <div class="text-right flex flex-nowrap mr-6 ml-5 mt-2">
          <div class="mr-2" v-if="course.reminderCompleteTime && new Date(course.reminderCompleteTime).getTime() < currentTime" >
             <clock size="30px" />
          </div>
          <h5
           class=" font-bold italic whitespace-no-wrap"
          :class="
            currentCourse == course._id
              ? ' text-primaryLink '
              : '  text-gray-700'
          "
          >
          {{course.enrolledMembers && course.enrolledMembers}} members
          </h5>
          <!-- <div class="tooltip" data-tip="Edit Segment">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['far', 'edit']"
              @click="$router.push(`/admin/products/${course._id}`)"
            />
          </div>
          <div class="tooltip" data-tip="Delete Segment">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['far', 'trash-alt']"
              @click="setModalDetails('course', course._id)"
            />
          </div>
          <div class="tooltip tooltip-left" data-tip="Duplicate Segment">
            <font-awesome-icon
              class="reaction text-gray-600 ml-4"
              size="lg"
              :icon="['fas', 'clone']"
              @click="clonecourse(course._id)"
            />
          </div> -->
        </div>
      </div>
    </div>
    <div class="flex" v-if="courses.length < totalCoursesCount">
      <button class="btn btn-outline mx-auto" @click="fetchCourseAgain">Load more</button>
    </div>
    <div class="rounded-md bg-blue-50 p-4">
      <div v-if="courses.length <= 0" class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: solid/information-circle -->
          <svg
            class="h-5 w-5 text-blue-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3 flex-1 md:flex md:justify-between">
          <p class="text-sm text-blue-700">
            There's no segments created right now.
          </p>
        </div>
      </div>
    </div>
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="feedPopup"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Delete Confirmation
              </div>
              <svg
                class="
                  ml-auto
                  fill-current
                  text-gray-700
                  w-6
                  h-6
                  cursor-pointer
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18 18"
                @click="closePopup"
              >
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                />
              </svg>
            </div>
            <hr class="w-full my-3" />
            <div class="">Are you sure you want to delete this?</div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="deleteConfirmed">
                Yes
              </button>
              <button class="btn btn-outline ml-3" @click="closePopup">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import courseAPI from '@/services/course';
import lessonAPI from '@/services/lesson';
import utils from '../../services/utils';
import clock from '../icons/clock.vue';

export default {
  components: { clock },
  name: 'CoursesList',
  props: ['courses', 'callback', 'currentCourse', 'fetchCourseAgain'],
  data() {
    return {
      userInfo: null,
      feedPopup: false,
      whatToDelete: '',
      deleteId: null,
      promoPopup: false,
      coursedata: [],
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
    totalCoursesCount() {
      return this.$store.state.courses.totalCourses;
    },
    currentTime() {
      return moment.now();
    },
  },
  methods: {
    loadMore() {
      console.log('loader');
    },
    closePopup() {
      this.feedPopup = false;
      this.promoPopup = this.whatToDelete === 'Tweet';
    },
    clonecourse(cid) {
      store.commit('toggleLoading', true);
      const payload = {
        courseId: cid,
      };
      console.log(payload);
      courseAPI
        .cloneCourse(payload)
        .then(() => {
          this.fetchCourseAgain();
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    setModalDetails(whatToDelete, deleteId) {
      this.whatToDelete = whatToDelete;
      this.deleteId = deleteId;
      this.feedPopup = true;
    },
    deleteConfirmed() {
      store.commit('toggleLoading', true);
      if (this.whatToDelete === 'course') {
        courseAPI
          .deleteCourse(this.deleteId)
          .then(() => {
            this.closePopup();
            this.fetchCourseAgain();
          })
          .catch((error) => {
            this.closePopup();
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            if (error.response.status === 400) {
              utils.setStatusMsg(this, error.response.data.message);
            }
            console.log({ error });
          });
      } else if (this.whatToDelete === 'Tweet') {
        console.log('delete tweetId >> ', this.deleteId);
        const payload = {
          tweetUrl: this.deleteId,
          courseId: this.coursedata._id,
        };
        courseAPI
          .deletePromo(payload)
          .then(async () => {
            utils.setStatusMsg(this, 'Announce Tweet Url Successfully Deleted');
            this.setpromoDetails(this.coursedata);
            this.closePopup();
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      } else {
        lessonAPI
          .deleteLesson(this.deleteId)
          .then(() => {
            this.closePopup();
            this.fetchCourseAgain();
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(
                this,
                'Unauthorized access, redirected to implicit',
              );
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      }
    },
  },
};
</script>
